import React, { useEffect, useState } from "react";
import { formatDate } from "@fullcalendar/core";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { useGetEventsMutation } from "../../features/auth/apiSlice";
import { useSelector } from "react-redux";
import { selectSponserID } from "../../features/auth/authSlice";
import AddEventModal from "../../models/AddEventModal";

const Index = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [currentEvents, setCurrentEvents] = useState([] as any);
  const [savedEvents, setSavedEvents] = useState([] as any);
  const [showModal, setShowModal] = useState(false);
  const [getEventsApi] = useGetEventsMutation();
  const sponserId = useSelector(selectSponserID);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const getEvents = async () => {
      const response: any = await getEventsApi(sponserId).unwrap();
      setSavedEvents(response?.events);
    };
    getEvents();
  }, [sponserId, getEventsApi]);

  const handleDateClick = (selected: any) => {
    // setSelected(selected);
    // setShowModal(true);
  };

  const handleEventClick = (selected: any) => {
    setShowModal(true);
    setSelected(selected);
  };

  return (
    <Box m="20px" sx={{ marginTop: "100px" }}>
      <Header title="CALENDAR" subtitle="Full Calendaar Interactive Page" />

      <Box display={"flex"} justifyContent="space-between">
        {/* CALENDAR SIDEBAR */}
        <Box
          flex={"1 1 20%"}
          bgcolor={colors.primary[400]}
          p="15px"
          borderRadius={"4px"}
        >
          <Typography variant="h5">Events</Typography>
          <List>
            {currentEvents.map((event: any) => (
              <ListItem
                key={event.id}
                sx={{
                  bgcolor: colors.greenAccent[500],
                  margin: "10px 0",
                  borderRadius: "2px",
                }}
              >
                <ListItemText
                  primary={event.title}
                  secondary={
                    <Typography>
                      {formatDate(event.start, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>

        {/* CALENDAR */}
        <Box flex={"1 1 100%"} ml="15px">
          <FullCalendar
            height={"75vh"}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin,
            ]}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
            }}
            initialView="dayGridMonth"
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            select={handleDateClick}
            eventClick={handleEventClick}
            eventsSet={(events) => setCurrentEvents(events)}
            events={savedEvents}
          />
        </Box>
      </Box>
      {showModal && (
        <AddEventModal setShowModal={setShowModal} selectedCal={selected} />
      )}
    </Box>
  );
};

export default Index;
